import { memoize, debounce } from 'lodash';
import getClientConfig from '../utils/getClientConfig';
import globalLogger from '../logger';
import { logAnalytics } from './analyticsInvocationUtils';

import { INTERCOM_OPERATIONS } from './analyticsConstants';
import { TIMES } from '../../common/utils/timeUtil';

const logger = globalLogger.createChannel('intercom');
const useIntercom = memoize(() => getClientConfig().analytics?.enabled);
export const intercomAvailable = () => window && typeof window.Intercom !== 'undefined';
const INTERCOM_BOOT_ACTION = INTERCOM_OPERATIONS.boot;

export const intercomAPI = (action) => (data, metadata) => {
    const isAvailable = useIntercom();

    logAnalytics('Intercom', isAvailable, action, data, metadata);

    if (!isAvailable) return;

    // Sensitive data audit: SAFE — Static warning about Intercom initialization status, no user data
    if (!intercomAvailable()) return logger.warn('Intercom not initialized yet');
    window.Intercom(action, data, metadata);
};

const intercomBootAction = intercomAPI(INTERCOM_BOOT_ACTION);
export const intercomBoot = (data = {}, metadata) => {
    const languageOverride = data?.localePreference;
    const intercomBootData = languageOverride
        ? {
              ...data,
              language_override: languageOverride,
          }
        : data;

    return intercomBootAction(intercomBootData, metadata);
};
export const intercomShutdown = intercomAPI(INTERCOM_OPERATIONS.shutdown);
export const intercomTrackEvent = intercomAPI(INTERCOM_OPERATIONS.trackEvent);
export const intercomShowMessenger = intercomAPI(INTERCOM_OPERATIONS.show);
export const intercomOnMessage = intercomAPI(INTERCOM_OPERATIONS.onUnreadCountChange);

export const intercomSetUserProperties = (userId, properties) =>
    intercomBoot({
        app_id: getClientConfig().analytics.appId,
        user_id: userId,
        ...properties,
    });

// Throttle intercom updates so we don't get throttled by them.
// Prod is on an Intercom SPA beta program with a much higher rate limit
const intercomUpdateAction = intercomAPI(INTERCOM_OPERATIONS.update);

export const intercomUpdate = debounce(
    intercomUpdateAction,
    TIMES.SECOND * getClientConfig().analytics?.debounceTimeSeconds,
    { maxWait: TIMES.SECOND * getClientConfig().analytics?.debounceMaxWaitSeconds },
);
